import React from 'react';

import './canvasPulsePoint.scss';

export default function CanvasPulsePoint() {
  return <div className="circle"></div>;
}
